import React from 'react'
import { InternalChatMessageFieldsFragment } from '~graphql/generated/graphql'
import TeamChatMessagePropertiesProvider, {
    useTeamChatMessageProperties,
} from './properties-provider'
import TeamChatTimestamp from './timestamp'
import TeamChatMessageItem from './item'

interface Props {
    message: InternalChatMessageFieldsFragment
    messageIndex: number
    allMessages: InternalChatMessageFieldsFragment[]
}

export default function TeamChatMessageContent({
    message,
    messageIndex,
    allMessages,
}: Props) {
    return (
        <TeamChatMessagePropertiesProvider
            message={message}
            messageIndex={messageIndex}
            allMessages={allMessages}
        >
            <TeamChatMessageContentInner />
        </TeamChatMessagePropertiesProvider>
    )
}

function TeamChatMessageContentInner() {
    const { message } = useTeamChatMessageProperties()

    return (
        <React.Fragment key={message.id}>
            <TeamChatTimestamp />
            <TeamChatMessageItem />
        </React.Fragment>
    )
}
